import React from 'react';
import PropTypes from 'prop-types';

import './spinner.css';

export const Spinner = ({noMargin, animated}) => {
    let extraClasses = [];

    if (noMargin === true) {
        extraClasses.push('no-margin');
    }

    if (animated === true) {
        extraClasses.push('animated');
        extraClasses.push('fadeIn');
    }

    return <div className={`spinner ${extraClasses.join(' ')}`}/>;
};


Spinner.propTypes = {
    noMargin: PropTypes.bool.isRequired,
    animated: PropTypes.bool.isRequired
};

Spinner.defaultProps = {
    noMargin: false,
    animated: false
};

export default Spinner;
